var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.20731 3.54036C8.46115 3.28652 8.87271 3.28652 9.12655 3.54036L13.1265 7.54036C13.2484 7.66225 13.3169 7.82759 13.3169 7.99998C13.3169 8.17237 13.2484 8.3377 13.1265 8.4596L9.12655 12.4596C8.87271 12.7134 8.46115 12.7134 8.20731 12.4596C7.95347 12.2058 7.95347 11.7942 8.20731 11.5404L11.0977 8.64998H3.33359C2.97461 8.64998 2.68359 8.35896 2.68359 7.99998C2.68359 7.64099 2.97461 7.34998 3.33359 7.34998H11.0977L8.20731 4.45959C7.95347 4.20575 7.95347 3.7942 8.20731 3.54036Z","fill":"currentColor"}));
}

ArrowRight.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
